'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const Translator = require('./../../../core/translator');
const FormBuilder = require('./../builder');
let ElementClass = require('./../elementClass');

FormBuilder.register('switch', function(config) {
    let self = {};
    config.onChange = config.onChange || jQuery.noop;

    self = new ElementClass(config);

    self.render = function($wrap) {
        self.isScalar = false;

        self.checked = [];
        self.options = [];
        self.isBoolean = false;

        if ((/number|string/).test(typeof config.options)) {
            self.options = [config.options];
            self.isScalar = true;
        } else if ('object' === typeof config.options) {
            self.options = config.options;
        }

        if ((/number|string/).test(typeof config.value)) {
            self.checked = [config.value];
        } else if ('object' === typeof config.value) {
            self.checked = config.value;
        } else if (_.isBoolean(config.value)) {
            self.isBoolean = true;
            self.isScalar = true;
            self.options.push([config.label]);
            if (config.value) {
                self.checked = ['0'];
            }
        }

        if (self.options.length > 1) {
            self.name = self.name + '[]';
        }

        _.forEach(self.options, function(option, key) {
            let $div = jQuery('<div/>').addClass('cloud-switch');
            let $input = jQuery('<input/>');
            let $label = jQuery('<label/>');
            let $indicator = jQuery('<span/>').addClass('cloud-switch-indicator');
            let $text = jQuery('<span />');

            if (config.sub_wrap_class) {
                $div.addClass(config.sub_wrap_class);
            }

            if (self.elementClass) {
                $input.addClass(self.elementClass);
            }

            if (self.labelClass) {
                $label.addClass(self.labelClass);
            }

            if (config.disabled) {
                $input.attr('disabled', 'disabled');
                $label.addClass('disabled');
            }

            $input.attr('type', 'checkbox');
            $input.attr('name', self.name);
            $input.attr('value', key);
            $text.text(Translator.translate(option));
            if (config.labelIcon) {
                $text.append(config.labelIcon);
            }
            $label.append($text);
            $label.append($input);
            $label.append($indicator);
            $div.append($label);

            $wrap.append($div);
        });

        $wrap.find('input[type=checkbox]').each(function() {
            let $input = jQuery(this);
            let onChange = function(...args) {
                    let $current = jQuery(this);

                    if (_.isArray(config.forbiddenElementsOnSwitchOn)) {
                        _.forEach(config.forbiddenElementsOnSwitchOn, (element) => {
                            let formElement = config.form.elements[element];

                            if (formElement.$) {
                                let $element = config.form.$.find(`.element_${element}`);

                                if ($current.is(':checked')) {
                                    $element.find('input').attr('disabled', 'disabled');
                                    $element.find('input').addClass('disabled');
                                } else {
                                    $element.find('input').removeAttr('disabled');
                                    $element.find('input').removeClass('disabled');
                                }
                            } else {
                                formElement.disabled = $current.is(':checked');
                            }
                        });
                    }

                    if (config.label_selected) {
                        $current.prev().text($current.is(':checked') ? Translator.translate(config.label_selected) : Translator.translate(config.label));
                    }

                    config.onChange.call(this, $current.prop('checked'), ...args);
                };

            $input.on('change', onChange);

            if (-1 !== self.checked.indexOf($input.val())) {
                $input.prop('checked', true);
            }

            onChange.apply($input);
        });

        return;
    };

    self.getData = function() {
        let data = (self.isBoolean) ? false : [];

        self.$.find('input').each(function() {
            let $input = jQuery(this);

            if ($input.is(':checked')) {
                if (true === self.isScalar) {
                    data = self.isBoolean ? true : $input.val();

                    return false;
                }

                data.push($input.val());
            }
        });

        return (true === self.isScalar) ? data : ((data.length > 0) ? data : null);
    };

    return self;
});
